var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 3.99998V3.46665C9.66667 2.71991 9.66667 2.34654 9.52134 2.06133C9.39351 1.81044 9.18954 1.60647 8.93865 1.47864C8.65344 1.33331 8.28007 1.33331 7.53333 1.33331H6.46667C5.71993 1.33331 5.34656 1.33331 5.06135 1.47864C4.81046 1.60647 4.60649 1.81044 4.47866 2.06133C4.33333 2.34654 4.33333 2.71991 4.33333 3.46665V3.99998M5.66667 7.66665V11M8.33333 7.66665V11M1 3.99998H13M11.6667 3.99998V11.4666C11.6667 12.5868 11.6667 13.1468 11.4487 13.5746C11.2569 13.951 10.951 14.2569 10.5746 14.4487C10.1468 14.6666 9.58677 14.6666 8.46667 14.6666H5.53333C4.41323 14.6666 3.85318 14.6666 3.42535 14.4487C3.04903 14.2569 2.74307 13.951 2.55132 13.5746C2.33333 13.1468 2.33333 12.5868 2.33333 11.4666V3.99998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin-icon.058ab1c4ae46de047dea84c7a658ba07.svg";
export { ForwardRef as ReactComponent };